import Tooltip from "./Tooltip";

export class SimpleViewTooltip extends Tooltip
{
    templateHtml()
    {
        return "<div class='simpleViewTooltip'></div>"
    }

    constructor($containerEl, extraClass)
    {
        super($containerEl);
        this.extraClass = extraClass;
    }

    afterRender()
    {
        super.afterRender();
        if (this.extraClass)
            this.$el.addClass(this.extraClass);
    }

    setView(view)
    {
        this.view = view;
        this.update();
    }

    shouldUpdateOnInit()
    {
        return false
    }

    update()
    {
        this.$el.empty();
        if (this.view)
            this.view.init(this.$el);
    }
}

export default SimpleViewTooltip;



// WEBPACK FOOTER //
// ./web/js/SimpleViewTooltip.js